import { FocusDto, TranscriptFocus } from '../../../coaching-base/general';
import {
    TagsDialogData,
    TagSetMode,
} from '../../../coaching-tags/tags/tags.model';
import { CallParticipant } from '../../../teams-call';

export function createTagsDialogData(
    participants: CallParticipant[],
    focuses: TranscriptFocus[],
): TagsDialogData {
    const performer = participants?.find((e) => e.isOrganizer !== true);
    const transcriptFocus = focuses?.find((e) => e.isPrimary === true);

    const selected: FocusDto = {
        userId: performer.userId,
        focusId: null,
        behaviourId: transcriptFocus?.behaviourId,
        subBehaviourId: transcriptFocus?.subBehaviourId,
        metrics: [],
    };

    // Todo rename store path
    const data: TagsDialogData = {
        storePathPrefix: 'coaching.transcriptDialogN',
        mode: TagSetMode.FOCUS_ONLY,
        focusSelectionParams: null,
        commitmentId: null,
        performerId: performer.userId,
        selected,
        pinnedMetrics: null,
    };
    return data;
}
